<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#app-layout{
        div.show-filters{
            height: 90px;
            width: 23px;
            position: absolute;
            left: 0px;
            background-color: white;
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            line-height: 90px;
            top: 50%;
            cursor: pointer;
            margin-top: -45px;
            z-index: 9;
            text-align: center;
        }

        .fade-enter-active, .fade-leave-active {
            transition: opacity .2s;
        }
        .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
        }
    }
</style>

<template>
    <div id="app-layout">
        <div class="show-filters" v-show="( !showFilters && servicesView == 'map' )" v-on:click="toggleShowFilters()">
            <img src="/img/grey-right.svg"/>
        </div>

        <transition name="fade">
            <FlashMessage v-show="flashMessage"/>
        </transition>

        <navigation></navigation>

        <router-view></router-view>

        <info-modal></info-modal>

        <contact-modal></contact-modal>

        <filters></filters>

        <pop-out></pop-out>

        <switch-type-modal></switch-type-modal>

        <cancel-scenario-modal :show="showCancelScenarioModal" :cancel-token="$route.query.st" @close-modal="closeCancelScenarioModal" />
    </div>
</template>

<script>
    import Navigation from '../components/global/Navigation.vue';
    import InfoModal from '../components/global/InfoModal.vue';
    import ContactModal from '../components/global/ContactModal.vue';
    import Filters from '../components/global/Filters.vue';
    import PopOut from '../components/global/PopOut.vue';
    import SwitchTypeModal from "../components/global/SwitchTypeModal";
    import CancelScenarioModal from "../components/global/CancelScenarioModal.vue";
    import FlashMessage from '../components/global/FlashMessage';
    import Geocode from '../api/geocode';
    import {mapState} from "vuex";

    export default {
        components: {
            Navigation,
            InfoModal,
            ContactModal,
            Filters,
            PopOut,
            SwitchTypeModal,
            CancelScenarioModal,
            FlashMessage
        },

        data() {
            return {
                showCancelScenarioModal: false
            }
        },

        created() {
            if (this.$route.query.st) {
                this.showCancelScenarioModal = true;
            }

            this.$store.dispatch('refreshJwt');

            this.jwtInterval = setInterval(() => {
                this.$store.dispatch('refreshJwt');
            }, 3600000);

            if (!this.distance) {
                this.$store.commit('setDistanceFilter', 10);
            } else {
                if (this.distance == 250) {
                    this.$store.commit('setDistanceFilter', 10);
                }
            }

            if (navigator.geolocation) {
                let timeoutId;
                let positionReceived = false;

                timeoutId = setTimeout(() => {
                    if (!positionReceived) {
                        if (this.workroom == 860) {
                            const PRAGUE_LAT = 50.08804;
                            const PRAGUE_LNG = 14.42076;

                            const praguePosition = this.createPositionObject(PRAGUE_LAT, PRAGUE_LNG);
                            this.setClientLocationAndLoadServices(praguePosition);
                        } else {
                            this.toggleShowFilters();
                        }
                    }
                }, 12000);

                navigator.geolocation.getCurrentPosition(position => {
                    positionReceived = true;
                    clearTimeout(timeoutId);
                    this.setClientLocationAndLoadServices(position);
                }, err => {
                    positionReceived = true;
                    clearTimeout(timeoutId);

                    if (this.workroom == 860) {
                        const PRAGUE_LAT = 50.08804;
                        const PRAGUE_LNG = 14.42076;

                        const praguePosition = this.createPositionObject(PRAGUE_LAT, PRAGUE_LNG);
                        this.setClientLocationAndLoadServices(praguePosition);
                    } else {
                        this.toggleShowFilters();
                    }

                    console.log('Geolocation error:', err.message, 'Code:', err.code);
                }, {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 300000
                });
            }
        },

        beforeDestroy() {
            if (this.jwtInterval) {
                clearInterval(this.jwtInterval);
            }
        },

        computed: {
            ...mapState({
                flashMessage: state => state.flashMessage.data.show
            }),

            licensePlate() {
                return this.$store.getters.getLicensePlate;
            },

            workroom() {
                return this.$store.getters.getWorkroom;
            },

            makeId() {
                return this.$store.getters.getMakeId;
            },

            clientLocation() {
                return this.$store.getters.getClientLocation;
            },

            distance() {
                return this.$store.getters.getDistanceFilter;
            },

            showFilters(){
                return this.$store.getters.getShowFilters;
            },

            servicesView() {
                return this.$store.getters.getServicesView;
            },
        },

        methods: {
            setClientLocationAndLoadServices(position) {
                Geocode.getCountryCodeFromPosition(position)
                    .then((response) => {
                        if (response != 'CZ') {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: 50.08804, longitude: 14.42076 } })
                        } else {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: position.coords.latitude, longitude: position.coords.longitude } })
                        }

                        this.$store.dispatch('loadServices', {
                            distance: this.distance,
                            workroom: this.workroom,
                            makeId: this.makeId,
                            licensePlate: this.licensePlate,
                            latitude: this.clientLocation.latitude,
                            longitude: this.clientLocation.longitude
                        });
                    })
                    .catch((error) => {
                        console.log(error)
                    });
            },

            createPositionObject(lat, lng) {
                return {
                    coords: {
                        latitude: lat,
                        longitude: lng,
                        accuracy: null,
                        altitude: null,
                        altitudeAccuracy: null,
                        heading: null,
                        speed: null
                    },
                    timestamp: Date.now()
                };
            },

            toggleShowFilters() {
                this.$store.dispatch('toggleShowFilters', {
                    showFilters : !this.showFilters
                });
            },

            closeCancelScenarioModal() {
                this.showCancelScenarioModal = false;

                const query = { ...this.$route.query };
                delete query.st;
                this.$router.replace({ query });
            }
        }
    }
</script>
